const shimmerGradient =
  "bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse";

const InboxEmailCardShimmer = () => {
  return (
    <div className="w-full border-b border-border-gray dark:border-border-gray-dk px-[12px] py-[14px] flex gap-[10px] min-w-0">
      <div className={`w-[24px] h-[24px] shrink-0 rounded-full ${shimmerGradient}`} />

      <div className="flex flex-col gap-[6px] min-w-0 flex-1">
        <div className="flex items-center justify-between gap-[8px]">
          <div className={`h-[14px] w-[60%] ${shimmerGradient}`} />
          <div className={`h-[12px] w-[50px] shrink-0 ${shimmerGradient}`} />
        </div>
        <div className={`h-[14px] w-[80%] ${shimmerGradient}`} />
        <div className={`h-[12px] w-[90%] ${shimmerGradient}`} />
      </div>
    </div>
  );
};

export default InboxEmailCardShimmer;
